import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

const InfoRow = ({ label, value, icon, colSize = "col-md-4" }) => {
    return (
        <div className={`${colSize} tw-mb-4`}>
            <div className="tw-flex tw-items-start tw-gap-2.5">
                {icon && (
                    <Icon
                        icon={icon}
                        className="tw-text-base tw-text-slate-400 tw-mt-0.5 tw-flex-shrink-0"
                    />
                )}
                <div className="tw-min-w-0">
                    <p className="tw-text-xs tw-text-slate-500 tw-mb-0.5">
                        {label}
                    </p>
                    <p className="tw-text-sm tw-font-medium tw-text-slate-800 tw-break-words">
                        {value || "-"}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default InfoRow;
